import {Card} from 'platform/components';
import styled from 'styled-components';

import type {ReactNode} from 'react';

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({theme}) => theme.colors.general.separator};
  border-radius: ${({theme}) => theme.radii.medium};
  background: ${({theme}) => theme.colors.palettes.white[10][100]};
`;
export const SectionCardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({theme}) => theme.getSize(3)};
  flex: 0 0 auto;
  padding: ${({theme}) => theme.getSize(4)};
  border-bottom: 1px solid ${({theme}) => theme.colors.general.separator};
`;
export const SectionCardContent = styled.div<{
  $flush?: boolean;
  $fill?: boolean;
  $cardBody?: boolean;
}>`
  display: ${({$fill}) => ($fill ? 'flex' : 'block')};
  flex: 1 1 auto;
  padding: ${({theme, $flush, $cardBody}) => ($flush || $cardBody ? 0 : theme.getSize(4))};
`;
export function PreviewSectionCard(props: {
  title?: string;
  flushContent?: boolean;
  fillContent?: boolean;
  children: ReactNode;
  'data-testid': string;
}) {
  return (
    <Card title={props.title} variant="inlineWhite" hasSeparator data-testid={props['data-testid']}>
      <SectionCardContent $flush={props.flushContent} $fill={props.fillContent} $cardBody>
        {props.children}
      </SectionCardContent>
    </Card>
  );
}
